import React from 'react';
import SingleVendorBreadcrumbs from '../shared/SingleVendorBreadcrumbs';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';

const ComplianceVendorBreadcrumbs = () => {
  return (
    <SingleVendorBreadcrumbs>
      <BreadcrumbItem>Compliance</BreadcrumbItem>
    </SingleVendorBreadcrumbs>
  );
};

export default ComplianceVendorBreadcrumbs;
